import React, { FC } from 'react';

import { BaseInput } from '../BaseInput';

import {
  EnhancedComponentProps,
  FormikProxy,
} from '~/components/inputs/FormikProxy';

interface Props {
  onChange: (e: any) => void;
  name: string;
  value: string;
}

export type TextInputProps = JSX.LibraryManagedAttributes<
  typeof TextInput,
  Props
>;

export const TextInputPrimitive: FC<Props> = props => {
  const { name, onChange, ...otherProps } = props;

  return (
    <BaseInput
      type="text"
      {...otherProps}
      id={name}
      onChange={e => {
        onChange(e.target.value);
      }}
    />
  );
};

TextInputPrimitive.defaultProps = {
  value: '',
};

const EnhancedTextInput: FC<EnhancedComponentProps<string>> = ({
  field,
  form,
  onChange,
  ...rest
}) => (
  <FormikProxy<string>
    field={field}
    form={form}
    onChange={onChange}
    render={formikProps => <TextInputPrimitive {...rest} {...formikProps} />}
  />
);

export const TextInput = Object.assign(EnhancedTextInput, {
  defaultProps: TextInputPrimitive.defaultProps,
});
try {
    // @ts-ignore
    TextInputPrimitive.displayName = "TextInputPrimitive";
    // @ts-ignore
    TextInputPrimitive.__docgenInfo = { "description": "", "displayName": "TextInputPrimitive", "props": { "onChange": { "defaultValue": null, "description": "", "name": "onChange", "required": true, "type": { "name": "(e: any) => void" } }, "name": { "defaultValue": null, "description": "", "name": "name", "required": true, "type": { "name": "string" } }, "value": { "defaultValue": { value: "" }, "description": "", "name": "value", "required": true, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/inputs/TextInput/TextInput.tsx#TextInputPrimitive"] = { docgenInfo: TextInputPrimitive.__docgenInfo, name: "TextInputPrimitive", path: "src/components/inputs/TextInput/TextInput.tsx#TextInputPrimitive" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    TextInput.displayName = "TextInput";
    // @ts-ignore
    TextInput.__docgenInfo = { "description": "", "displayName": "TextInput", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/inputs/TextInput/TextInput.tsx#TextInput"] = { docgenInfo: TextInput.__docgenInfo, name: "TextInput", path: "src/components/inputs/TextInput/TextInput.tsx#TextInput" };
}
catch (__react_docgen_typescript_loader_error) { }